import { useQuery } from '@tanstack/react-query';

import { SideBarSectionContainer } from 'DesignSystem/features/sidebar';
import SidebarDetailContent from 'DesignSystem/features/sidebar/SidebarDetailContent';
import LongText from 'components/LongText';
import { prefCardItemDetailsQuery, usePrefCardCases } from 'pages/preference-cards/api';
import { CardConflictDifferenceType } from 'pages/preference-cards/types';
import { formatTableNumber } from 'utils/helpers';

import { CasesDialog } from '../../cases-dialog/cases-dialog';

type ItemSummaryProps = {
  cardId: string;
  itemId: string;
  itemName: string;
  mfgName: string | null;
  mfgCatalogId: string | null;
  differenceType?: CardConflictDifferenceType | undefined;
  isPack?: boolean;
  packComponentCount?: number | null;
  canFetchItemDetails?: boolean;
};

export function ItemSummary(props: ItemSummaryProps) {
  const shouldFetchItemDetails =
    (props.canFetchItemDetails ?? true) &&
    (props.isPack || (props.differenceType !== 'ADD' && props.differenceType !== undefined));
  const { data: item } = useQuery(prefCardItemDetailsQuery(props.cardId, props.itemId, shouldFetchItemDetails));
  const { data: caseCount } = usePrefCardCases(
    props.cardId,
    {
      for_preference_card_client_item_master_ids: props.itemId,
      page_size: '0',
    },
    {
      select: (data) => data.result_set_size,
    }
  );

  return (
    <div className="flex flex-col gap-y-1">
      <SideBarSectionContainer>
        <SidebarDetailContent label="Manufacturer" classNames="pr-1">
          <LongText text={props.mfgName || '–'} className="max-w-44" />
        </SidebarDetailContent>
        <SidebarDetailContent label="Item ID" classNames="pr-1">
          <LongText text={props.mfgCatalogId || '–'} className="max-w-48" />
        </SidebarDetailContent>
        <SidebarDetailContent label="ERP Price" classNames="pr-1">
          <LongText
            text={
              typeof item?.purchase_uom_price === 'number'
                ? formatTableNumber(item.purchase_uom_price, { type: 'currency' })
                : '–'
            }
          />
        </SidebarDetailContent>
        {props.isPack ? (
          <SidebarDetailContent label="Components" classNames="pr-1">
            <LongText text={typeof props.packComponentCount === 'number' ? String(props.packComponentCount) : '–'} />
          </SidebarDetailContent>
        ) : null}
      </SideBarSectionContainer>

      {typeof caseCount === 'number' ? (
        <CasesDialog
          itemId={props.itemId}
          caseCount={caseCount}
          differenceType={props.differenceType}
          isPack={props.isPack}
          canFetchItemDetails={props.canFetchItemDetails}
        />
      ) : null}
    </div>
  );
}
